module.exports = __webpack_public_path__ + "media/Images/tpa-faq-image2-211aedbebaf9c71da241ba43dd1e0397.jpg";